import React from 'react';
import IvsCodesPageContent from "../../IvsCode/Containers/IvsCodesPageContent";

export default function IvsCodesPage() {
    return (
        <IvsCodesPageContent />
    );
}
